import type { AuthConfig } from '@bravemove/types';
import { adminFetch } from '../auth/apiClient';

/**
 * FIX 5.27 (§13.11-13) — `GET /auth/config`, the public platform config the
 * portal and mobile read (legal versions + `features`). The admin console
 * reads only `features.whatsapp`, to hide the WhatsApp tooling while delivery
 * is deferred. Public route: the admin bearer adminFetch attaches is ignored.
 */
export async function getAuthConfig(): Promise<AuthConfig> {
  const body = await adminFetch<{ readonly data: AuthConfig }>('/auth/config');
  return body.data;
}
